import React from "react";
import {
  TableCell,
  ListItemButton,
  ListItemText,
  Typography,
  styled,
  Pagination,
} from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import makeStyles from "@mui/styles/makeStyles";

export const DrawerContent = styled("div")(({ theme }) => ({
  minWidth: "210px",
  maxWidth: "150px",
  padding: "16px 12px",
}));

export const StyledDrawerTitle = styled("div")({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: "15px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
});

export const StyledListItemButton = styled(ListItemButton)(() => ({
  display: "flex",
  height: "48px",
  padding: "8px 12px",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
  "&.selected": {
    background: "rgba(0, 85, 164, 0.12)",
  },
  "&:hover": {
    background: "rgba(0, 85, 164, 0.12)",
  },
}));

export const StyledListItemText = styled(ListItemText)({
  "& .MuiListItemText-primary": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
});

// Header cell styles
export const StyledHeaderCell = styled(TableCell)({
  padding: "8px 16px",
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  "&.checkbox-cell": {
    width: "48px",
    minWidth: "48px",
    padding: "8px 0px 8px 16px",
  },
});

// Content cell styles
export const StyledContentCell = styled(TableCell)(() => ({
  height: "64px",
  minHeight: "40px",
  maxHeight: "64px",
  padding: "0px 16px",
  display: "table-cell",
  verticalAlign: "middle",
  color: colors.gray600,
  "&.checkbox-cell": {
    width: "48px",
    minWidth: "48px",
    padding: "0px 0px 0px 16px",
  },
  "&.actions-cell": {
    "& > div": {
      display: "flex",
      gap: "12px",
      justifyContent: "center",
    },
  },
}));

export const PaginationContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
  marginTop: "16px",
  boxShadow: "none",
});

export const PageSizeSection = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: colors.gray600,
  "& .MuiTablePagination-select": {
    paddingBottom: 0,
  },
  "& .MuiTablePagination-selectLabel": {
    margin: 0,
  },
});

export const StyledPagination = styled(Pagination)({
  display: "flex",
  justifyContent: "center",
  gap: "0",

  "&.MuiPaginationItem-root": {
    color: colors.gray600,
    boxShadow: "none",
    minWidth: "44px",
    minHeight: "44px",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    border: `1px solid ${colors.gray200}`,
    borderRadius: "8px",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },

    "& .MuiSvgIcon-root": {
      width: "20px",
      height: "20px",
    },

    "&.MuiPagination-ul": {
      border: `1px solid ${colors.gray200}`,
      borderRadius: "8px",
    },
  },

  "& .MuiPaginationItem-page.Mui-selected": {
    backgroundColor: "white",
    color: colors.brandBlue500,
    fontWeight: 700,
  },

  "& .MuiPaginationItem-page:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const StyledPaginationText = styled(Typography)({
  color: colors.gray600,
  textAlign: "right",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
});

export const StyledPaginationSpan = styled("div")({
  color: colors.gray600,
  textAlign: "right",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
});

export const MainContainer = styled("div")({
  display: "flex",
});

export const ContentContainer = styled("div")({
  flexGrow: 1,
  marginLeft: "16px",
});

export const ContentWrapper = styled("div")({
  background: "transparent",
});

export const FlexContainer = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "16px",
});

export const ActionsContainer = styled("div")({
  display: "flex",
  gap: "12px",
  justifyContent: "center",
});

export const SelectAllText = styled("div")({
  color: colors.brandBlue500,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  padding: "10px 12px",
});

const styles = makeStyles(() => ({
  notificationWrapper: {
    "& .shipeezi-new-grid-component table .tr-header th:first-child": {
      paddingLeft: "0px !important",
    },
    "& .MuiTableCell-root.MuiTableCell-body > div > div > *": {
      marginLeft: "0px !important",
    },
  },
}));

export default styles;
